<template>
  <v-dialog v-model="visible" scrollable persistent max-width="800" @keydown.esc="cancelForm()">
    <v-card class="grua-form-card">
      <v-card-title class="primary white--text py-4">
        <v-icon left color="white">{{ isNewRecord ? 'mdi-truck-plus' : 'mdi-truck-edit' }}</v-icon>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cancelForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-form ref="gruaForm" v-model="validations.isValid">
          <v-container fluid>
            <!-- Información de la Empresa -->
            <v-row>
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-office-building</v-icon>
                  <span>Información de la Empresa</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.company" :rules="validations.company" :error-messages="errors.company"
                  :disabled="loading" label="Nombre de la Empresa*" prepend-inner-icon="mdi-domain" required outlined
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.cif" :rules="validations.cif" :error-messages="errors.cif"
                  :disabled="loading" label="CIF*" prepend-inner-icon="mdi-identifier" required outlined
                  dense></v-text-field>
              </v-col>
            </v-row>

            <!-- Información de Contacto -->
            <v-row class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-contact-phone</v-icon>
                  <span>Información de Contacto</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.phone" :rules="validations.phone" :error-messages="errors.phone"
                  :disabled="loading" label="Teléfono*" prepend-inner-icon="mdi-phone" required outlined
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.email" :rules="validations.email" :error-messages="errors.email"
                  :disabled="loading" label="Correo Electrónico*" prepend-inner-icon="mdi-email-outline" required
                  outlined dense></v-text-field>
              </v-col>
            </v-row>

            <!-- Selección de Dealer (solo para colaboradores) 
            <v-row v-if="$store.getters.HAS_ROLE(['colaborator'])" class="mt-2">
              <v-col cols="12">
                <div class="section-title">
                  <v-icon color="primary" left>mdi-store</v-icon>
                  <span>Asignación de Dealer</span>
                </div>
              </v-col>-->
              <!--<v-col cols="12">
                <v-autocomplete
                  v-model="fields.dealer_id"
                  :items="availableDealers"
                  :loading="loadingDealers"
                  :rules="$store.getters.HAS_ROLE(['colaborator']) ? validations.dealer_id : []"
                  :error-messages="errors.dealer_id"
                  :disabled="loading"
                  item-value="id"
                  item-text="name"
                  label="Dealer*"
                  prepend-inner-icon="mdi-store"
                  outlined
                  dense
                  clearable
                  required
                >
                  <template v-slot:selection="{ item }">
                    <v-icon left small :color="item.is_own ? 'primary' : 'grey'">
                      {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                    </v-icon>
                    {{ item.name }}
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon left :color="item.is_own ? 'primary' : 'grey'">
                      {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                    </v-icon>
                    <span>{{ item.name }}</span>
                    <v-chip v-if="item.is_own" x-small class="ml-2" color="primary">Propio</v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>-->
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" @click="cancelForm()" color="grey darken-1" text class="px-4">
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn :loading="loading" :disabled="saveIsDisabled" @click="saveForm()" color="primary" class="px-4" depressed>
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import GruaService from '../../services/GruaService'
// import UserService from '../../services/UserService'
// import DealerService from '../../services/DealerService'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    created: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    visible: true,
    loading: false,
    loadingDealerships: false,
    loadingDealers: false,
    dealershipOptions: [],
    availableDealers: [],

    // campos del formulario
    fields: {
      company: null,
      cif: null,
      phone: null,
      email: null,
      dealer_id: null
    },

    // validaciones
    validations: {
      isValid: true,
      company: [
        (v) => !!v || 'Debe proporcionar el nombre de la empresa.'
      ],
      cif: [
        (v) => !!v || 'Debe proporcionar el CIF.',
        (v) => /^[a-zA-Z0-9-]+$/.test(v) || 'El CIF solo puede contener letras, números y guiones.'
      ],
      phone: [
        (v) => !!v || 'Debe proporcionar un teléfono.',
        (v) => /^[0-9]+$/.test(v) || 'El teléfono solo puede contener números.'
      ],
      email: [
        (v) => !!v || 'Debe proporcionar un correo electrónico.',
        (v) => /.+@.+\..+/.test(v) || 'Debe ser un correo electrónico válido.'
      ],
      dealer_id: [
        (v) => !!v || 'Debe seleccionar un dealer.'
      ]
    },

    // errores
    errors: {
      company: [],
      cif: [],
      phone: [],
      email: [],
      dealer_id: []
    }
  }),

  computed: {
    ...mapGetters(['CURRENT_USER']),
    isNewRecord () {
      return !this.value || !this.value.id || this.created
    },
    title () {
      return this.isNewRecord ? 'Nueva Grúa' : 'Modificar Grúa'
    },
    saveIsDisabled () {
      return this.loading || !this.validations.isValid
    }
  },

  async created () {
    // Cargar opciones de concesionarios
    // this.loadDealerships()
    
    // Cargar dealers accesibles si es colaborador
    // if (this.$store.getters.HAS_ROLE(['colaborator'])) {
      // await this.loadAvailableDealers()
    // }

    // Cargar datos si estamos editando
    if (this.value && this.value.id) {
      this.loading = true
      await this.$store.dispatch('VIEW_GRUA', { ...this.value, expand: 'dealership' }).then(result => {
        this.fields = Object.assign({}, this.value)
        
        // Si es colaborador y la grúa tiene dealer, cargar el dealer_id
        // if (this.$store.getters.HAS_ROLE(['colaborator']) && this.value.dealership) {
        //   this.fields.dealer_id = this.value.dealership.id
        // }
        
        this.loading = false
      })
    }
  },

  methods: {
    // async loadDealerships () {
    //   this.loadingDealerships = true
    //   try {
    //     const response = await UserService.getMe()
    //     if (response && response.data && response.data.data) {
    //       this.dealershipOptions = response.data.data.dealer.id
    //     }
    //   } catch (error) {
    //     console.error('Error al cargar concesionarios:', error)
    //     this.$toast.error('No se pudieron cargar los concesionarios')
    //   } finally {
    //     this.loadingDealerships = false
    //   }
    // },

    // async loadAvailableDealers () {
    //   if (!this.$store.getters.HAS_ROLE(['colaborator'])) {
    //     return
    //   }

    //   try {
    //     this.loadingDealers = true
    //     const response = await DealerService.getMyAccessibleDealers()
        
    //     // Verificar la estructura de la respuesta
    //     let dealersArray = []
    //     if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
    //       dealersArray = response.data.data.data
    //     } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
    //       dealersArray = response.data.data
    //     } else if (response.data && Array.isArray(response.data)) {
    //       dealersArray = response.data
    //     }
        
    //     this.availableDealers = dealersArray
    //   } catch (error) {
    //     console.error('Error al cargar dealers accesibles:', error)
    //     this.$toast.error('Error al cargar la lista de dealers')
    //   } finally {
    //     this.loadingDealers = false
    //   }
    // },

    async saveForm () {
      this.$refs.gruaForm.validate()
      if (this.validations.isValid) {
        this.loading = true

        try {
          let grua = Object.assign({}, this.fields)
          // grua.dealership_id = this.dealershipOptions
          
          // Si es colaborador, usar el dealer seleccionado
          // if (this.$store.getters.HAS_ROLE(['colaborator'])) {
            grua.dealership_id = this.CURRENT_USER.dealer.id
          // }
          
          const response = await this.$store.dispatch(
            this.isNewRecord ? 'ADD_GRUA' : 'UPDATE_GRUA',
            grua
          )

          if (response.error) {
            if (response.status === 422) {
              response.data.forEach(({ field, message }) => {
                if (this.errors[field]) {
                  this.errors[field].push(message)
                }
              })
            } else {
              console.log(response.data)
              this.$toast.error('Ocurrió un error al intentar registrar o actualizar la grúa')
            }
            this.loading = false
            return
          }

          // Emitir evento de éxito con los datos de la grúa
          this.$emit('save', { insert: this.isNewRecord, value: response.data })
          this.$toast.success(`Grúa ${this.isNewRecord ? 'creada' : 'actualizada'} correctamente`)
          this.visible = false
        } catch (error) {
          console.error('Error general:', error)
          this.$toast.error('Ocurrió un error inesperado')
        } finally {
          this.loading = false
        }
      }
    },

    cancelForm () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.grua-form-card {
  border-radius: 8px;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.87);
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.section-title .v-icon {
  margin-right: 8px;
}
</style>
